// extracted by mini-css-extract-plugin
module.exports = {"pageList":"PageList_pageList__R8D6J","ingress":"PageList_ingress__JAneX","list":"PageList_list__RYxVZ","row":"PageList_row__sQQsV","date":"PageList_date__BBQ0j"};